import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiName } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiNameDialogData {
  names?: ApiName[];
}

@Component({
  selector: 'app-multi-floor-dialog',
  templateUrl: './multi-floor-dialog.component.html',
  styleUrls: ['./multi-floor-dialog.component.css'],
  standalone: false,
})
export class MultiFloorDialogComponent implements OnInit {

  //名称×言語数
  names: ApiName[] = [];
  namesFormGroup!: FormGroup;
  namesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiFloorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiNameDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.names = this.data.names!;
    if (!this.names) {
      this.names = [];
    }
    this.createForm();
    this.namesArrayControl = this.namesFormGroup.get('names') as FormArray;
    this.currentLang = this.translate.currentLang;
  }

  //名称フォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.names.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let name = '';
      let trans_name = '';
      for (const value of this.names) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          name = value.name;
          trans_name = value.trans_name;
          break
        }
      }
      arrayControl.push(this.formBuilder.group(
        {
          autoTrans: [auto_trans],
          name: [name],
          transName: [trans_name],
        }
      ));
      index++;
    }
    this.namesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        names: arrayControl
      }
    );
  }

  //更新ボタン
  addNames(): void {
    if (this.namesFormGroup.valid) {
      let names = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.namesArrayControl.controls[index];
        names.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            name: ctrl.get('name')!.value,
            trans_name: ctrl.get('transName')!.value,
          }
        )
      }
      this.names = names;
      this.dialogRef.close(this.names);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.namesFormGroup.get('autoAllTrans')!.value;
    for (const name of this.namesArrayControl.controls) {
      name.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.namesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const name of this.namesArrayControl.controls) {
      if (!name.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.namesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
